export default __webpack_public_path__ + "static/media/layer1.c8835982.svg";